import { toast } from "@/hooks/use-toast";

export interface RateLimitConfig {
  action: string;
  limit: number;
  window: string;
}

const RATE_LIMIT_MESSAGES: Record<string, RateLimitConfig> = {
  meeting_create: {
    action: "create meetings",
    limit: 10,
    window: "hour"
  },
  meeting_join: {
    action: "join meetings",
    limit: 20,
    window: "hour"
  },
  chat_message: {
    action: "send messages",
    limit: 30,
    window: "minute"
  }
};

export const handleRateLimitError = (error: any, actionType?: string) => {
  const errorMessage = error?.message || error?.toString() || '';
  
  // Check if this is a rate limit error
  if (errorMessage.includes('check_rate_limit') || 
      errorMessage.includes('rate limit') ||
      errorMessage.includes('violates row-level security policy')) {
    
    const config = actionType ? RATE_LIMIT_MESSAGES[actionType] : null;
    
    toast({
      title: "Rate Limit Exceeded",
      description: config 
        ? `You can only ${config.action} ${config.limit} times per ${config.window}. Please try again later.`
        : "You're doing that too often. Please slow down and try again later.",
      variant: "destructive",
    });
    
    return true; // Indicates this was a rate limit error
  }
  
  return false; // Not a rate limit error
};

export const isRateLimitError = (error: any): boolean => {
  const errorMessage = error?.message || error?.toString() || '';
  return errorMessage.includes('check_rate_limit') || 
         errorMessage.includes('rate limit') ||
         (errorMessage.includes('violates row-level security policy') && 
          errorMessage.includes('Rate limit'));
};
